<template>
    <div class="col-lg-9">
        <h2 class="font-weight-400 mb-3">Transaction History</h2>

        <!-- Filter ============================================= -->
        <div class="row">
            <div class="col mb-2">
                <form @submit.prevent="data.fetch()" class="row my-4 align-items-center pr-3">

                    <div class="col-lg-2">
                        <select @change="data.fetch()" v-model="data.filters.size" class="custom-select" required="">
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="25">25</option>
                            <option value="30">30</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div class=" col-lg-3 col-6 input-group py-1">
                        <input
                            type="date"
                            class="form-control"
                            v-model="tempStartDate"
                            placeholder="Start Date"
                        />
                    </div>
                    <div class="col-lg-3 col-6 input-group py-1">
                        <input
                            type="date"
                            class="form-control"
                            v-model="tempEndDate"
                            placeholder="End Date"
                        />
                    </div>
                    <div class="input-group col-lg-3 ml-auto">
                        <div class="input-group-prepend"> <span class="input-group-text bg-white"><i class="fas fa-search"></i></span> </div>
                        <input type="text" class="form-control"  v-model="data.filters.search" placeholder="Search....">
                    </div>
                    <button @click.prevent="data.fetch()" :class="['btn btn-primary btn-sm text-white px-3 shadow-none' , data.loading ? 'btn-loading' : '']"><i class="fas fa-arrow-alt-circle-right"></i></button>
                </form>
            </div>
        </div>
        <!-- Filter End -->

        <!-- All Transactions ============================================= -->
        <div class="bg-light shadow-sm rounded py-4 mb-4">
            <div class="d-flex justify-content-center align-items-center mb-4 px-4">
                <div class="d-flex align-items-center mb-0">
                    <h3 class="text-4 font-weight-700 d-flex align-items-center mb-0">
                        All Transactions
                    </h3>
                </div>
                <button
                    class="btn btn-outline-primary btn-sm shadow-none ml-auto"
                    @click="downloadStatement"
                >
                    <i class="fas fa-download mr-2"></i>Report
                </button>
            </div>
            <transition name="shake">
                <div v-if="message" class="m-auto mb-4">
                    <small  class="alert alert-danger center-text">{{ message }}</small>
                </div>
            </transition>

            <!-- Title =============================== -->
            <div class="transaction-title py-2 px-4">
                <div class="row">
                    <div class="col-2 col-sm-1 text-center"><span class="">Date</span></div>
                    <div class="col col-sm-7">Description</div>
                    <div class="col-auto col-sm-2 d-none d-sm-block text-center">Status</div>
                    <div class="col-3 col-sm-2 text-right">Amount</div>
                </div>
            </div>
            <!-- Title End -->

            <!-- Transaction List
            =============================== -->
            <div class="transaction-list">
                <router-link v-for="row in data.content.data"
                             :key="row.id"
                             :to="`/business/view?ref=${row.ref}`"
                             class="transaction-item d-block px-4 py-3">
                    <div class="row align-items-center flex-row">
                        <div class="col-2 col-sm-1 text-center">
                            <span class="d-block text-4 font-weight-300">{{ row.day }}</span>
                            <span class="d-block text-1 font-weight-300 text-uppercase">{{ row.month }}</span>
                        </div>
                        <div class="col col-sm-7">
                            <span class="d-block text-4">Transaction #{{ row.code }}</span>
                            <span class="text-muted">{{ row.state }}</span>
                        </div>
                        <div class="col-auto col-sm-2 d-none d-sm-block text-center text-3" :title="row.state">
                            <span v-if="row.state.includes('AUTHORISATION-REQUIRED')" class="text-warning">
                                <i class="fas fa-exclamation-triangle"></i>
                            </span>
                            <span v-if="row.state.includes('COMPLETED')" class="text-success">
                                <i class="fas fa-check-circle"></i>
                            </span>
                        </div>
                        <div class="col-3 col-sm-2 text-right text-4">
                            <span class="text-nowrap">{{ money(row.meta.total) }}</span>
                            <span class="text-2 text-uppercase">({{ row.payment_currency }})</span>
                        </div>
                    </div>
                </router-link>
            </div>
            <!-- Transaction List End -->

            <!-- Pagination ============================================= -->
            <div class="d-flex align-items-center justify-content-between px-4">
                <span class="text-black-50">
                    Showing {{ data.content.data.length }} of {{ data.content.total }} Records
                </span>
                <ul class="pagination justify-content-center mt-4 mb-0">
                    <li class="page-item disabled">
                        <a class="page-link" href="#" tabindex="-1">
                            <i class="fas fa-angle-left"></i>
                        </a>
                    </li>
                    <li class="page-item active">
                        <a @click="data.append()"
                           v-if="data.content.total !== data.content.to && data.content.data.length > 0"
                           class="page-link" href="#">
                            Load More <span class="sr-only">(current)</span>
                        </a>
                    </li>
                    <li class="page-item d-flex align-content-center flex-wrap text-muted text-5 mx-1">
                        <span>...</span>
                    </li>
                    <li class="page-item disabled">
                        <a class="page-link" href="#" tabindex="-1">
                            <i class="fas fa-angle-right"></i>
                        </a>
                    </li>
                </ul>
            </div>
            <!-- Paginations end -->
        </div>
    </div>
</template>

<script>
import Data from "../../../core/data/Data";
import {money} from "../../../core/forms/money";
import Form from "../../../core/forms/form";

export default {
    name: "Index",
    mixins: [money],
    data() {
        return {
            data: new Data({
                url: "/business/batches/list",
                prefix: "list"
            }),
            batch: {},
            user: window.user,
            message:'',
            tempStartDate: '',
            tempEndDate: '',
            form: new Form({
                startDate: '',
                endDate: ''
            }),
        };
    },
    computed: {
        batchStatusColor() {
            if (this.batch.state === 'AUTHORISATION-REQUIRED') return 'text-warning';
            if (this.batch.state === 'COMPLETED') return 'text-success';
            if (this.batch.state === 'REJECTED') return 'text-danger';

            return 'text-muted';
        }
    },
    methods : {
        downloadStatement() {
            this.message = '';
            if (!this.tempStartDate || !this.tempEndDate) {
                this.message = "Please set both the start date and end date before downloading the statement.";
                return;
            }
            const payload = {
                startDate: this.tempStartDate,
                endDate: this.tempEndDate,
            };
            axios.post(`/business/batches/generate-statement`, payload, {
                responseType: 'blob',
            })
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `report_${new Date().toISOString().slice(0, 19)}.xlsx`;
                    link.click();
                })
                .catch((error) => {
                    console.error("Error downloading report:", error);
                });
        },
    },
    mounted() {
        this.data.fetch()
    }
}
</script>
<style scoped>
.center-text {
    display: block;
    text-align: center;
}
</style>

